import React from 'react';

function AEMock() {
  return (
    <li className="u-els-padding-left-1o2">
      <div className="rx-ae-indicator dropdown pos-right-bottom">
        <span className="ss-record button-icon" />
        <div className="dropdown-menu">
          <div className="dropdown-menu--content">Using A&E mock</div>
        </div>
      </div>
    </li>
  );
}

export default AEMock;
